import React from 'react'
import { Link } from 'react-router-dom'

import './index.less'

const NoAuthority = () =>(
 
  <main className = "errorPage">
    <div className = "img-bar">
      <img className = "img-status" src = {require('../../assets/403.svg')} alt = "403" />
    </div>
    <div className = "tip">
      <span className = "tip-status">
        403
      </span>
      <span className = "tip-text">
        抱歉，你无权访问该页面
      </span>
      <Link to = "/home" className = "tip-btn">返回首页</Link>
    </div>
  </main>

)

export default NoAuthority